import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "tone-picker",
    style: _normalizeStyle({ '--jsValueH': _ctx.modelValue.s / 100, '--jsValueV': 1 - _ctx.modelValue.v / 100 })
  }, [
    _createElementVNode("div", {
      ref: "container",
      class: "container",
      onPointerdown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startDrag($event)))
    }, [
      _createElementVNode("div", {
        class: "layer",
        style: _normalizeStyle({ background: _ctx.baseColor })
      }, null, 4 /* STYLE */),
      _createElementVNode("div", {
        class: "layer",
        style: _normalizeStyle({ background: `linear-gradient(90deg, white, transparent)` })
      }, null, 4 /* STYLE */),
      _createElementVNode("div", {
        class: "layer",
        style: _normalizeStyle({ background: `linear-gradient(0deg, black, transparent)` })
      }, null, 4 /* STYLE */),
      _createElementVNode("div", {
        class: _normalizeClass(['knob', { active: !!_ctx.moveHandler }])
      }, null, 2 /* CLASS */)
    ], 544 /* HYDRATE_EVENTS, NEED_PATCH */)
  ], 4 /* STYLE */))
}